import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import { Subscription } from "./SubscriptionInfo";

const POLL_INTERVAL = 2000;
const MAX_ATTEMPTS = 4; 

const PaymentLoader: React.FC = () => {
  const [status, setStatus] = useState("Checking payment...");
  const navigate = useNavigate();

  useEffect(() => {
    let attempts = 0;
    const intervalId = setInterval(async () => {
      try {
        const url = `${process.env.REACT_APP_BASEURL}/users/subscriptions/status/`;
        const response = await axiosInstance.get<{ subscriptions: Subscription[] }>(url);

        const subscriptions = response.data.subscriptions || [];
        const targetProduct = localStorage.getItem("product_name_from_plans");

        const match = subscriptions.find(
          (sub) => sub.product_name === targetProduct && sub.subscribed === true,
        );

        if (match) {
          setStatus("Payment successful! Redirecting...");
          clearInterval(intervalId);
          setTimeout(() => navigate("/home"), 1500);
          return;
        }

        setStatus("Waiting for confirmation...");
        attempts++;
        if (attempts >= MAX_ATTEMPTS) {
          setStatus("Payment confirmation timed out. Redirecting...");
          clearInterval(intervalId);
          setTimeout(() => navigate("/plans"), 2000);
        }
      } catch (err) {
        console.error("Error verifying payment:", err);
        setStatus("Error verifying payment. Redirecting...");
        clearInterval(intervalId);
        setTimeout(() => navigate("/plans"), 2000);
      }
    }, POLL_INTERVAL);

    // Cleanup: stop polling if component unmounts
    return () => clearInterval(intervalId);
  }, [navigate]);

  return (
    <div className="payment-loader">
      <div className="loader-circle"></div>
      <p className="status-text">{status}</p>

      <style>{`
        .payment-loader {
          background-color: #FBE5C6; /* White background */
          color: #FF9A56; /* Dark blue text */
          font-family: 'Segoe UI', sans-serif;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
        }

        .loader-circle {
          width: 70px;
          height: 70px;
          border: 6px solid rgba(255, 154, 86, 0.2); /* Faded blue */
          border-top: 6px solid #FF9A56; /* Dark blue spinner */
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 20px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .status-text {
          font-size: 1.2rem;
          font-weight: 500;
          margin-top: 10px;
          color: #FF9A56;
        }
      `}</style>
    </div>
  );
};

export default PaymentLoader;
